<template>
  <masonry
    :cols="{ default: 3, 580: 2, 768: 4, 960: 1, 1200: 2 }"
    :gutter="{ default: '13px', 768: '13px', 960: '0' }"
    class="element-items"
  >
    <!-- Elements -->
    <ItemPreviewCard
      v-for="element in elements"
      :key="element.elementId"
      type="button"
      :class="{ selected: isSelected(element) }"
      @click="onElementClick(element)"
    >
      <div v-if="element.status === 'PUBLIC'" class="element-price">
        {{ element.price | formatPrice }}
      </div>

      <div
        v-if="element.status === 'PRIVATE' && upgradeRequired"
        class="element-price"
      >
        Premium
      </div>

      <v-icon
        v-if="loadingPreview && isSelected(element)"
        name="spinner"
        class="v-center loader-icon"
        :scale="1.25"
        spin
      />

      <!-- <div v-if="isSelected(element)" class="delete-helper">
        <v-icon name="times-circle" :scale="1" />

        <span class="delete-helper-label">Delete?</span>
      </div> -->

      <img
        v-if="$get(element, 'previewImage.src')"
        v-lozad="$get(element, 'previewImage.src')"
        :alt="$get(element, 'previewImage.alt')"
        class="element-thumb"
        :class="{ 'opacity-50': loadingPreview }"
      />
    </ItemPreviewCard>
  </masonry>
</template>

<script>
import ItemPreviewCard from "@/components/UI/ItemPreviewCard";
import EventBus from "@/lib/event-bus.js";

export default {
  name: "ElementsListMasonry",
  inject: ["DEVELOPMENT"],
  components: { ItemPreviewCard },
  props: {
    elements: {
      type: Array,
      default: () => [],
    },
    selectedElementId: {
      type: String,
      default: "",
    },
    upgradeRequired: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loadingPreview: false,
    };
  },
  mounted() {
    this.setupEventBus();
  },
  beforeDestroy() {
    this.deleteEventBus();
  },
  methods: {
    deleteEventBus() {
      EventBus.$off("preview-loading");
    },
    isSelected(element) {
      return this.selectedElementId === element.elementId;
    },
    onElementClick(element) {
      if (!this.loadingPreview && !this.isSelected(element)) {
        this.$emit("element-click", element);
      }
    },
    setupEventBus() {
      EventBus.$on("preview-loading", (loading) => {
        this.loadingPreview = loading;
      });
    },
  },
};
</script>

<style scoped>
.element-items {
  @apply w-full;
  margin-top: 21px;
}

>>> .item-preview-card {
  @apply w-full relative;
  margin-bottom: 21px;
  padding: 5px;

  &.selected {
    @apply border-success;

    &:hover {
      @apply cursor-not-allowed;
      transform: scale(1);

      .delete-helper {
        @apply opacity-100;
      }
    }
  }
}

.element-thumb {
  @apply block mb-0 overflow-hidden rounded-lg;
  padding: 5px;
}

.element-price {
  @apply absolute text-xs bg-brand-light font-lato rounded shadow uppercase text-brand border border-brand-lighter;
  font-size: 12px;
  opacity: 0.9;
  padding: 3px 5px;
  right: -5px;
  transform: rotate(3deg);
  top: -5px;
}

.loader-icon {
  @apply absolute mx-auto block text-brand;
  left: 0;
  right: 0;
  z-index: 1;
}

/* .delete-helper {
  @apply opacity-0 flex items-center absolute text-danger p-1 rounded-br bg-white font-lato;
  font-size: 12px;
  left: 5px;
  top: 5px;
  transition: opacity 0.2s linear;

  &:hover {
    .delete-helper-label {
      @apply block;
    }
  }
}

.delete-helper-label {
  @apply ml-1 hidden;
} */
</style>
